$(document).on('turbolinks:load', function() {
  $('#departments-table').dataTable({
    "processing": true,
    "serverSide": true,
    "ajax": {
      "url": $('#departments-table').data('source')
    },
    "pagingType": "full_numbers",
    "columns": [
      {"data": "name"},
      {"data": "ops"},
    ], 
    columnDefs: [{ "orderable": false, "targets": 1 }, { "width": "5%", "targets": 1 }]
  });
});